import Vue from 'vue'
import Router from 'vue-router'
import Customers from './views/customer/Customers.vue'
import Detail from './views/customer/Detail.vue'
import BindFirst from './views/error/BindFirst.vue'
import { getToken, setToken, removeToken } from '@/utils/auth'

const T = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1NTk5NjQ1MjIsImlhdCI6MTU1NzM3MjUyMiwidXNlcklkIjoxLCJjb21wYW55SWQiOjIsIm5pY2tuYW1lIjoi5byg5peg5b-MIn0.18hCwY3F_lsshem31SmUTtVOImA4Lhp5WaM36SVsZAs'
const url = BASE_API.PHP
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/customerlist',
      name: 'customerlist',
      component: Customers,
    },
    {
      path: '/customer/detail/:taskId/:phone',
      name: 'detail',
      component: Detail,
    },
    {
      path: '/error/bindfirst',
      name: 'bindfirst',
      component: BindFirst,
    },
  ],
})

router.beforeEach((to, from, next) => {
  // alert(to.query.token)
  // removeToken()
  // return
  if (to.name !== 'detail' && to.name !== 'customerlist') {
    next()
    return
  }
  const paramToken = to.query.token
  if (paramToken) {
    setToken(paramToken)
    next()
  } else {
    const localToken = getToken()
    if (localToken) {
      next()
    } else {
      // window.location.href = `https://dev-api-wx.gooki.com/customerlist?token=${T}`
      window.location.href = `${url}/wechat/access`
    }
  }
})

export default router
